<template>
  <span>
    <v-icon class="mr-2" small @click="getUserToken">
      mdi-link
    </v-icon>

    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="headline">
          Dedicated voting URL for {{ user.firstName }} {{ user.lastName }}
        </v-card-title>

        <v-card-text>
          <textarea
            v-if="!loading"
            :key="user._id"
            style="width:100%; height:100px;"
            :class="'clipboard-' + user._id"
            :value="'https://app.agmify.com/live/?tk=' + token"
          >
          </textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="copyToClipboard">
            Copy URL
          </v-btn>

          <v-btn color="green darken-1" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import { mapState } from 'vuex';
import api from '@/services/api';
export default {
  props: ['user'],
  data() {
    return {
      dialog: false,
      token: null,
      loading: false
    };
  },
  computed: {
    ...mapState({
      event: (state) => state.events.event
    })
  },
  methods: {
    async getUserToken() {
      this.token = null;
      this.dialog = true;
      this.loading = true;
      this.token = await api.generateToken(this.user._id);
      if (!this.token) {
        this.token = 'unable to fetch token';
      }
      this.loading = false;
    },
    async copyToClipboard() {
      const textArea = document.querySelector('.clipboard-' + this.user._id);
      textArea.select();
      document.execCommand('copy');
    }
  }
};
</script>
